import { ChangeDetectionStrategy, Component, EventEmitter, forwardRef, Input, Output } from "@angular/core";
import { DefaultValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from "@angular/forms";
import { IconModule } from "src/app/shared/ui/icon/icon.module";

@Component({
  selector: "tpm-text-field",
  templateUrl: "text-field.component.html",
  styleUrls: ["text-field.component.scss"],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormsModule, IconModule],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TextFieldComponent),
      multi: true
    }
  ]
})
export class TextFieldComponent extends DefaultValueAccessor {
  @Output("ngModelChange") readonly update = new EventEmitter<string | null | undefined>();

  @Input({ required: true }) name: string;
  @Input() placeholder: string | null | undefined;
  @Input() icon: string | null | undefined;
  @Input() disabled: boolean = false;
  @Input("ngModel") model: string | null | undefined;
}
